import React, { useState } from "react";
import "./AlertPercentage.css";
import { TiDelete } from "react-icons/ti";

const AlertPercentage = () => {
  const [AlertPercentage, setAlertPercentage] = useState(true);

  const CloseAlert = () => {
    setAlertPercentage(false);
  };

  return (
    <>
      {AlertPercentage === true ? (
        <div className="alerts-container">
          <div className="boxalertpercentage">
            <p className="textalertpercentage">
              <strong>A PARTIR DE LA VENTA DE OCTUBRE</strong>
              <br />
              <br />
              Estimado comercializador,
              <br />
              <br />
              Le informamos que, debido a los recientes aumentos en los
              créditos, las escalas de comisiones han sido ajustadas. Estas
              comisiones están indexadas al Salario Mínimo, Vital y Móvil, tal
              como lo establece el anexo correspondiente.
              <br />
              <br />
              Nuevas escalas:
              <br />
              <br />
              - Hasta $9.000.000: 7%
              <br />
              - De $9.000.001 a $12.000.000: 9%
              <br />
              - Más de $12.000.001: 11%
              <br />
              <br />
              <br />
              Agradecemos su comprensión y colaboración.
              <br />
              <br />
              Atentamente,
              <br />
              Amebo
            </p>
            <TiDelete className="iconalertpercentage" onClick={CloseAlert} />
          </div>
          <div className="boxalertpercentage">
            <p className="textalertpercentage">
              <strong>AVISO IMPORTANTE</strong>
              <br />
              <br />
              Estimado comercializador,
              <br />
              <br />
              Desde febrero de 2026, las comisiones se pagan el 5° día hábil. La
              factura debe cargarse hasta el 4° día hábil a las 18:00 hs.
              <br />
              <br />
              Facturas cargadas luego de ese horario se abonarán el día 15 o
              hábil siguiente. Las ventas estarán disponibles el primer día
              hábil del mes en el portal.
              <br />
              <br />
              — Comisión Directiva
              <br />
              Saludos
            </p>
            <TiDelete className="iconalertpercentage" onClick={CloseAlert} />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AlertPercentage;
